import styled from 'styled-components';

export const TimerDiv = styled.div<{
  edit?: boolean;
  minimize?: boolean;
}>`
  border-radius: 5px;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  ${(props) =>
    props.edit
      ? `margin-right: 10px;
         margin-left: 10px;`
      : `background-color: ${props.theme.palette.background.timer};
         width: 100px;
         padding: 2px;
         height: 25px;`}
  ${(props) => (props.minimize ? `height: 20px;` : ``)}
  ${(props) => (props.edit ? `;` : `box-shadow: 0 0 10px #dc143c;`)}
`;

export const EditTimeDiv = styled.div`
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: flex-start;
`;

export const TimerText = styled.span`
  font-size: 1.2rem;
  font-weight: 600;
  padding: 1px;
`;

export const EditVisitDiv = styled.div`
  display: flex;
  justify-content: flex-start;
  flex-direction: left;
  flex-wrap: wrap;
  gap: 5px;
`;
